import styled from "styled-components";

/**
 * Body layout for the location-cell hover tooltips (evidence LocationCell and
 * storage StorageCurrentLocationCell). Class hooks are consumed by
 * CopyableRow and LatestCocSection; `.footer` wraps LatestCocSection's
 * optional footer slot (today only the evidence cell's "View full chain of
 * custody" link) and is inert when no footer is passed.
 */
const TooltipBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 280px;
  max-width: 380px;
  font-size: 12px;
  color: ${({ theme }) => theme.palette.text.primary};

  .row {
    display: flex;
    gap: 8px;
  }
  .label {
    color: ${({ theme }) => theme.palette.text.secondary};
    min-width: 110px;
    flex-shrink: 0;
  }
  .value {
    white-space: pre-line;
    word-break: break-word;
    flex: 1;
    min-width: 0;
  }
  .tooltip-title {
    font-size: 0.85rem;
    font-weight: 600;
    color: ${({ theme }) => theme.palette.text.primary};
    margin-bottom: 2px;
  }
  .tooltip-title:not(:first-child) {
    margin-top: 6px;
    padding-top: 8px;
    border-top: 1px solid ${({ theme }) => theme.palette.divider};
  }
  .copyable-value {
    display: flex;
    align-items: center;
    gap: 6px;
    flex: 1;
    min-width: 0;
    cursor: pointer;
    padding: 2px 4px;
    margin: -2px -4px;
    border-radius: 3px;

    &:hover,
    &:focus-visible {
      background-color: ${({ theme }) => theme.palette.action.hover};
      .copy-icon {
        visibility: visible;
      }
    }
    &:focus-visible {
      outline: 2px solid ${({ theme }) => theme.palette.primary.main};
      outline-offset: 1px;
    }
  }
  .copy-icon {
    visibility: hidden;
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.palette.text.secondary};
    margin-left: auto;
    flex-shrink: 0;

    &[data-copied="true"] {
      visibility: visible;
      color: ${({ theme }) => theme.palette.success.main};
    }
  }
  .footer {
    margin-top: 4px;
    padding-top: 8px;
    border-top: 1px solid ${({ theme }) => theme.palette.divider};
  }
  .muted {
    color: ${({ theme }) => theme.palette.text.secondary};
    font-style: italic;
  }
`;

export default TooltipBody;
